<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/store/auth'
const auth = useAuthStore(), route = useRoute()
const manager = computed(() => route.meta.manager === true), base = computed(() => manager.value ? '/manager' : '/account')
</script>
<template>
  <div class="account-shell">
    <div class="portal-account-context"><span>{{ manager ? '기업 교육담당자' : '내 계정' }}</span><NuxtLink v-if="auth.isManager" :to="manager ? '/account' : '/manager/account'">{{ manager ? '내 계정으로' : '담당자 계정으로' }}</NuxtLink></div>
    <nav class="account-nav" aria-label="계정 메뉴"><div><NuxtLink :to="manager ? '/manager/account' : '/account'" exact-active-class="active">계정 정보</NuxtLink><NuxtLink :to="`${base}/profile`" active-class="active">내 정보</NuxtLink><NuxtLink v-if="manager" to="/manager/companies" active-class="active">담당 기업</NuxtLink><NuxtLink v-if="manager" to="/manager/contracts" active-class="active">위탁훈련 계약</NuxtLink><NuxtLink :to="`${base}/security`" active-class="active">보안 설정</NuxtLink></div></nav>
    <nav v-if="manager" class="account-nav" aria-label="수강 관리 메뉴"><div><NuxtLink to="/manager/enrollments" active-class="active">담당 수강 관리</NuxtLink><NuxtLink to="/manager/applications" active-class="active">수강 신청·승인</NuxtLink><NuxtLink to="/manager/bulk" active-class="active">일괄 입과</NuxtLink><NuxtLink to="/manager/learning" active-class="active">담당 학습 현황</NuxtLink><NuxtLink to="/manager/assessments" active-class="active">담당 평가 현황</NuxtLink><NuxtLink to="/manager/completions" active-class="active">담당 수료 현황</NuxtLink></div></nav>
    <section class="account-main"><NuxtPage /></section>
  </div>
</template>

<style scoped>
/* 담당 메뉴가 늘어나도 작은 화면에서 모든 링크를 읽고 선택할 수 있도록 줄을 나눈다. */
.account-shell, .account-nav, .account-main { min-width: 0; }
.account-nav { max-width: 100%; }
.account-nav > div { min-width: 0; flex-wrap: wrap; }
.account-nav a { flex-shrink: 0; }
</style>

